import ContactEmergencyIcon from '@mui/icons-material/ContactEmergency';
import { Button } from '@mui/material';
import React, { useEffect, useState } from 'react';

import { CUSTOM_EVENTS } from '../../utils/constants';

// FONT-AWESOME is used as an exception here, should use MUI icons when possible
// if necessary, don't forget to add the font-awesome icon to the library in parsys_cloud\js\main.js
const ICON_MAP = {
  contactPhone: <ContactEmergencyIcon />,
  mapLocationDot: <i className='fa-solid fa-map-location-dot' />,
};


const CopyButton = ({ id, label, destinationFields, examType, icon }) => {
  const [hasValuesToCopy, setHasValuesToCopy] = useState(false);

  useEffect(() => {
    const checkSourceInputValues = () => {
      const hasValueAndNotEqual = destinationFields.some(destId => {
        const destinationInput = document.getElementById(`consultation-${examType}-${destId}`);
        if (!destinationInput) {
          return false;
        }

        const sourceInput = document.getElementById(destinationInput.dataset.copyFrom);
        return (sourceInput && sourceInput.value.trim() !== '');
      });

      setHasValuesToCopy(hasValueAndNotEqual);
    };

    checkSourceInputValues();

    // Add event listener on source inputs
    destinationFields.forEach(destId => {
      const destinationInput = document.getElementById(`consultation-${examType}-${destId}`);
      if (!destinationInput) {
        return;
      }

      const sourceInput = document.getElementById(destinationInput.dataset.copyFrom);
      if (!sourceInput) {
        return;
      }

      sourceInput.addEventListener('input', checkSourceInputValues);
      sourceInput.addEventListener(CUSTOM_EVENTS.FIELD_UPDATED, checkSourceInputValues);
    });

    // Cleanup event listeners on unmount
    return () => {
      destinationFields.forEach(destId => {
        const destinationInput = document.getElementById(`consultation-${examType}-${destId}`);
        if (!destinationInput) {
          return;
        }

        const sourceInput = document.getElementById(destinationInput.dataset.copyFrom);
        if (!sourceInput) {
          return;
        }

        sourceInput.removeEventListener('input', checkSourceInputValues);
        sourceInput.removeEventListener(CUSTOM_EVENTS.FIELD_UPDATED, checkSourceInputValues);
      });
    };
  }, [destinationFields, examType]);

  const handleClick = () => {
    destinationFields.forEach(destId => {
      const destinationInput = document.getElementById(`consultation-${examType}-${destId}`);
      const sourceInput = document.getElementById(destinationInput.dataset.copyFrom);
      if (sourceInput && sourceInput.value !== '') {
        destinationInput.value = sourceInput.value;
      }
    });
  };

  return (
    <Button
      id={id}
      type='button'
      variant='contained'
      component='button'
      disabled={!hasValuesToCopy}
      onClick={handleClick}
      startIcon={ICON_MAP[icon]}
      sx={{
        marginLeft: '15px',
        marginY: '6px',
      }}
    >
      {label}
    </Button>
  );
};

export default CopyButton;
